import React from 'react'
import * as styles from './helpcenter.module.css'

const HelpCenterHeader = props => {
  const padding = props.padding
  const { title } = props
  return (
    <>
      <div
        className={`${styles.header} ${padding ? styles.padding : undefined}`}
      >
        <div className={styles.text}>
          <h1>{title}</h1>
        </div>
      </div>
    </>
  )
}

export default HelpCenterHeader
